var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { sliceColorInfo } from '../utils/slice-color-info';
import { OrganisationBioCell } from './organisation-bio-cell';
import { useEntity } from '../hooks/use-entity';
import { Grid } from '../elements/grid';
var cls = classNames('organisation-bio-grid');
export var SliceOrganisationBioGridDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    a {\n      text-decoration: none;\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    a {\n      text-decoration: none;\n    }\n  "]))),
  landscape: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-items: flex-start;\n    flex-wrap: wrap;\n    flex-direction: row;\n  "], ["\n    align-items: flex-start;\n    flex-wrap: wrap;\n    flex-direction: row;\n  "])))
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    flex-basis: calc(20% - ", ");\n  "], ["\n    margin-bottom: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    flex-basis: calc(20% - ", ");\n  "])), theme.UNIT(10), theme.UNIT(5), theme.UNIT(5), theme.UNIT(10)),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "], ["\n    margin-bottom: ", ";\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "])), theme.UNIT(4))
});
var GridStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n   \n  "], ["\n   \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: styled(Grid)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Organisation: styled(OrganisationBioCell)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles)
};
export var SliceOrganisationBioGrid = function (props) {
  var className = props.className,
    children = props.children;
  var entity = useEntity(props.entity);
  var _a = entity.organisations,
    organisations = _a === void 0 ? [] : _a;
  var isInverted = sliceColorInfo(entity).isInverted;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(Grid, {
    desktopAutoColumns: 1,
    tabletAutoColumns: 1,
    items: organisations.map(function (organisation) {
      var logo = organisation && (isInverted ? organisation.logoInverted || organisation.logo : organisation.logo);
      return React.createElement(My.Organisation, {
        key: organisation.id,
        entity: __assign(__assign({}, organisation), {
          logo: logo
        }),
        logoSize: 140
      });
    })
  }));
};
SliceOrganisationBioGrid.defaultProps = SliceOrganisationBioGridDefaultProps;
SliceOrganisationBioGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;